import React, { useMemo, useEffect } from "react";
import { Label, FormFeedback, FormGroup } from "reactstrap";
import Select from "react-select/async";
import { getRegions } from "common/services/regions.service";
import { normalize } from "common/lib/normalize";
import {
  GroupBase,
  OptionsOrGroups,
} from "react-select/dist/declarations/src/types";

const SelectAdminLevel0 = ({ validation }: { validation: any }) => {
  const customSelectStyles = {
    control: (styles: any) => ({
      ...styles,
      borderColor:
        validation.touched.adminLevel0 && validation.errors.adminLevel0
          ? "red"
          : "#ced4da",
      "&:hover": {
        borderColor:
          validation.touched.adminLevel0 && validation.errors.adminLevel0
            ? "red"
            : "#ced4da",
      },
    }),
  };

  const [data, setData] = React.useState<any>([]);
  const [loading, setLoading] = React.useState<boolean>(false);

  const countryId = validation?.values?.country?.value;

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        let filters = {
          level: 0,
          country: countryId,
        };

        const response = await getRegions({
          pagination: {
            page: 1,
            pageSize: 20,
          },
          filters,
        });
        setData(normalize(response.data));
      } catch (e) {
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [countryId]);

  const options = useMemo(() => {
    return data.map((el: any) => {
      return {
        value: el?.id,
        label: `${el?.name}`,
      };
    });
  }, [data]);

  return (
    <FormGroup>
      <Label htmlFor="adminLevel0-field" className="form-label">
        Select Administration Level 0
      </Label>
      <Select
        name="adminLevel0"
        id="adminLevel0"
        value={
          validation?.values?.adminLevel0?.value
            ? validation?.values?.adminLevel0
            : null
        }
        placeholder="Select admin level 0"
        validate={{
          required: { value: true },
        }}
        onChange={(value: any) => {
          validation.setFieldValue("adminLevel0", value);
          validation.setFieldError("adminLevel0", "");
          validation.setFieldValue("adminLevel1.value", null);
        }}
        defaultOptions={options}
        // @ts-ignore
        loadOptions={(
          inputValue: string,
          callback: (options: OptionsOrGroups<any, GroupBase<any>>) => void
        ) => {
          return getRegions({
            pagination: {
              page: 1,
              perPage: 20,
            },
            filters: {
              $or: [
                {
                  name: {
                    $containsi: inputValue,
                  },
                },
              ],
              level: 0,
            },
          }).then((result: any) => {
            const parsedData = normalize(result.data);
            callback(
              parsedData.map((el: any) => {
                return {
                  value: el?.id,
                  label: `${el?.name}`,
                };
              })
            );
          });
        }}
        onBlur={() => validation.setFieldTouched("adminLevel0", true)}
        className={
          validation.touched.adminLevel0 && validation.errors.adminLevel0
            ? "is-invalid"
            : ""
        }
        styles={customSelectStyles}
        isLoading={loading}
      />
      <FormFeedback>{validation.errors.adminLevel0?.value}</FormFeedback>
    </FormGroup>
  );
};

export default SelectAdminLevel0;
